import { render, staticRenderFns } from "./PluginEditionPrice.vue?vue&type=template&id=28b67676"
import script from "./PluginEditionPrice.vue?vue&type=script&lang=js"
export * from "./PluginEditionPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports